import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useOutsideClick } from '~/core/utils/hooks'
import { useDropdownStyles } from './styles'

const Dropdown = ({ buttonProps, containerProps, icon, id, items, label, listProps, listPull }) => {
  const [isOpen, setOpen] = useState(false)
  const dropdownRef = useRef(null)
  const classes = useDropdownStyles()

  useOutsideClick(dropdownRef, () => setOpen(false), isOpen)

  return (
    <div
      ref={dropdownRef}
      id={id}
      {...containerProps}
      className={classnames(
        'btn-dropdown-icon',
        {
          active: isOpen
        },
        containerProps.className
      )}
    >
      <button
        data-target="parent"
        data-toggle="dropdown"
        data-toggle-icon=""
        type="button"
        onClick={() => setOpen(!isOpen)}
        {...buttonProps}
        className={classnames('btn btn-flat', buttonProps.className)}
      >
        {icon && <i className="icon icon-m">{icon}</i>}
        {label}
      </button>
      <ul
        {...listProps}
        className={classnames(
          'dropdown-list',
          {
            'dropdown-list-to-left': listPull === 'left' || !listPull,
            'dropdown-list-to-right': listPull === 'right'
          },
          listProps.className
        )}
      >
        {items.map(({ content, itemProps = {}, isDisabled }) => (
          <li
            key={itemProps.id}
            className={classnames(itemProps.className, {
              [classes.disabled]: isDisabled
            })}
          >
            <a
              {...itemProps}
              className="dropdown-list_item"
              onClick={e => {
                if (typeof itemProps.onClick === 'function') itemProps.onClick(e)
                setOpen(false)
              }}
            >
              {content}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

Dropdown.propTypes = {
  id: PropTypes.any,
  icon: PropTypes.string,
  label: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      itemProps: PropTypes.object
    })
  ),
  containerProps: PropTypes.object,
  buttonProps: PropTypes.object,
  listProps: PropTypes.object,
  listPull: PropTypes.oneOf(['left', 'right'])
}

Dropdown.defaultProps = {
  items: [],
  buttonProps: {},
  containerProps: {},
  listProps: {}
}

export default Dropdown
